import React from "react";
import GitHubCalendar from 'github-calendar'
class Git_calender extends React.Component {
  componentDidMount() {
    GitHubCalendar(
        document.getElementById("cal"), "choudharyanuj", {
        responsive: true
    });
  }
  render() {
    return <div id="cal" className="text-dark" style={{textDecoration:"none"}}></div>;
  }
}
export default Git_calender;


// WEBPACK FOOTER //
// ./src/component/projects.jsx